var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhatsappBlack = function SvgWhatsappBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.979,
    height: 17.983,
    viewBox: "0 0 17.979 17.983",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp-black-icon",
    transform: "translate(0.021 -0.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M17.958,14.393c0,.1,0,.312-.009.477a9.47,9.47,0,0,1-.095,1.161,3.869,3.869,0,0,1-.326.973,3.465,3.465,0,0,1-1.522,1.524,3.877,3.877,0,0,1-.978.326,9.505,9.505,0,0,1-1.153.093c-.165.006-.379.009-.476.009H4.543c-.1,0-.312,0-.477-.009a9.475,9.475,0,0,1-1.161-.1,3.87,3.87,0,0,1-.973-.322A3.465,3.465,0,0,1,.406,17a3.876,3.876,0,0,1-.323-.978,9.512,9.512,0,0,1-.095-1.153c-.006-.165-.009-.379-.009-.476V5.538c0-.1,0-.312.009-.477A9.474,9.474,0,0,1,.082,3.9,3.869,3.869,0,0,1,.41,2.927,3.465,3.465,0,0,1,1.935,1.4a3.879,3.879,0,0,1,.978-.326A9.5,9.5,0,0,1,4.067.983c.165-.006.379-.009.476-.009H13.4c.1,0,.312,0,.477.009a9.475,9.475,0,0,1,1.161.095,3.869,3.869,0,0,1,.973.326,3.465,3.465,0,0,1,1.52,1.527,3.876,3.876,0,0,1,.326.978,9.516,9.516,0,0,1,.093,1.153c.006.165.009.379.009.476v8.854Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(2.67 3.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M164.307,137.48a6.449,6.449,0,0,0-10.149,7.778l-.915,3.341,3.421-.9a6.445,6.445,0,0,0,3.079.784h0A6.449,6.449,0,0,0,164.3,137.48Zm-4.56,9.921h0a5.353,5.353,0,0,1-2.728-.747l-.2-.116-2.029.532.541-1.977-.127-.2a5.359,5.359,0,1,1,4.541,2.511Zm2.939-4.013c-.161-.08-.954-.47-1.1-.524s-.257-.08-.363.08-.417.524-.513.631-.188.121-.349.04a4.4,4.4,0,0,1-1.3-.8,4.854,4.854,0,0,1-.9-1.112c-.094-.162-.01-.248.07-.328s.161-.188.242-.282a1.1,1.1,0,0,0,.161-.269.3.3,0,0,0-.014-.282c-.04-.08-.363-.873-.5-1.2s-.264-.272-.363-.276-.2-.006-.309-.006a.592.592,0,0,0-.428.2,1.806,1.806,0,0,0-.564,1.344,3.13,3.13,0,0,0,.658,1.666,7.185,7.185,0,0,0,2.753,2.43,9.276,9.276,0,0,0,.919.342,2.21,2.21,0,0,0,1.014.064,1.659,1.659,0,0,0,1.088-.77,1.346,1.346,0,0,0,.094-.77c-.04-.068-.148-.108-.309-.188Z",
    transform: "translate(-153.243 -135.591)",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsappBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp-black.5cac8e3d.svg";
export { ForwardRef as ReactComponent };